import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../integrations/supabase/client';

export function useSystemSettings() {
  const queryClient = useQueryClient();

  const { data: settingsList, isLoading } = useQuery({
    queryKey: ['system-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('system_settings')
        .select('key, value');
      if (error) throw error;
      return (data || []).reduce((acc: Record<string, unknown>, { key, value }) => {
        acc[key] = value;
        return acc;
      }, {});
    },
  });

  const updateSetting = useMutation({
    mutationFn: async ({ key, value }: { key: string; value: string | unknown }) => {
      const { error } = await supabase
        .from('system_settings')
        .upsert(
          { key, value, updated_at: new Date().toISOString() },
          { onConflict: 'key' }
        );
      if (error) throw error;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['system-settings'] }),
  });

  return { settings: settingsList ?? {}, isLoading, updateSetting };
}
